import ShopArticleTaxResourceListResultModel from '../../generated/types/model/resource/ShopArticleTaxResourceListResultModel';

export default class ShopArticleTaxResourceListResultViewModel extends ShopArticleTaxResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
